import { Backdrop, CircularProgress, styled } from '@mui/material';
import { useAppSelector } from '@store/hooks';
import React from 'react';

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  color: '#fff',
  zIndex: theme.zIndex.modal + 1,
  // display: 'flex',
  // flexDirection: 'column',
  // gap: theme.spacing(2),
  // backgroundColor: '#000a',
  backdropFilter: 'blur(3px)',
}));

const LoadingOverlay: React.FC = () => {
  const { isLoading } = useAppSelector(state => state.loading);

  if (!isLoading) return null;

  return (
    <LoadingIndicator open={isLoading} />
  );
};

interface LoadingIndicatorProps {
  open?: boolean;
}

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ open = true }) => {
  return (
    <StyledBackdrop open={open}>
      <CircularProgress color="inherit" size={48} thickness={2.5} />
    </StyledBackdrop>
  );
};

export default LoadingOverlay;
